import { render, staticRenderFns } from "./CompanionAudioGuide.vue?vue&type=template&id=0825e7da&scoped=true&lang=pug&"
import script from "./CompanionAudioGuide.vue?vue&type=script&lang=js&"
export * from "./CompanionAudioGuide.vue?vue&type=script&lang=js&"
import style0 from "./CompanionAudioGuide.vue?vue&type=style&index=0&id=0825e7da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0825e7da",
  null
  
)

export default component.exports